import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { translateProviders } from './translation.config';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakInitService } from './core/services/utils/keycloak-init.service';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

registerLicense(environment.syncfusionLicenseKey);

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (keycloakInit: KeycloakInitService) =>
        keycloakInit.initializeKeycloak(),
      multi: true,
      deps: [KeycloakInitService],
    },
    KeycloakService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Ordre significatif : tokenInterceptor pose l'en-tête Authorization,
    // errorInterceptor est le plus proche du réseau et voit donc l'erreur en premier.
    provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    ...translateProviders,
  ],
};
